import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { Board } from './routes/Board.tsx';
import { Setup } from './routes/Setup.tsx';
import { StopEditor } from './routes/StopEditor.tsx';
import { UpdatePrompt } from './components/UpdatePrompt.tsx';
import { Toast } from './components/Toast.tsx';

export function App() {
  return (
    <BrowserRouter>
      {/* pb clears the iOS home indicator; the app has no fixed bottom bar. */}
      <div className="mx-auto max-w-lg px-4 pt-6 pb-[calc(2rem+env(safe-area-inset-bottom))]">
        <Routes>
          <Route path="/" element={<Board />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/setup/:siteId" element={<StopEditor />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Toast />
      <UpdatePrompt />
    </BrowserRouter>
  );
}
